// src/pages/ProfilePage.js
import { useEffect, useState } from "react";
import { supabase } from "../util/supabaseClient";
import { useLocation } from "react-router-dom";

// 👇 ADD THIS HERE
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ProfilePageB() {
 // console.log("hi");

  const query = useQuery();
  const owner_id = query.get("owner_id");
  //const { username } = useParams();
 // console.log("owner_id:", owner_id);


  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [friendsPostCount, setFriendsPostCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (owner_id) {
      fetchData();
    }
  }, [owner_id]);

  const fetchData = async () => {
    setLoading(true);

    // fetch profile
    const { data: profileData, error } = await supabase
      .from("public_profiles")   // ✅ use the VIEW
      .select("*")
      .eq("id", owner_id)
      .single();

    setProfile(profileData);
    console.log("profile:", profileData);


    // fetch posts
    const { data: postsData } = await supabase
      .from("public_posts")
      .select("*")
      .eq("user_id", owner_id)
      .order("created_at", { ascending: false });

    setPosts(postsData || []);
    setLoading(false);


    // fetch post count (friends visibility only)
    const { data: postCount, error: countError } = await supabase
      .rpc("get_friends_post_count", { p_user_id: owner_id });


    if (countError) {
      console.error(countError);
    } else {
      console.log("Friends posts count:", postCount);
      setFriendsPostCount(postCount || 0);

    }
  };

  console.log("posts:", posts);


  const generateFakeText = () => {
    const words = ["lorem", "ipsum", "dolor", "sit", "amet", "hidden", "private", "content"];
    return Array.from({ length: 8 }, () =>
      words[Math.floor(Math.random() * words.length)]
    ).join(" ");
  };

  if (!owner_id) return <p>Invalid profile link</p>;
  if (loading) return <p>Loading...</p>;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img
          src={
            profile?.avatar_url
              ? supabase.storage.from('profile-images').getPublicUrl(profile.avatar_url).data.publicUrl
              : supabase.storage.from('profile-images').getPublicUrl("default-avatar-2.png").data.publicUrl
          }
          alt="profile_image"
          style={styles.avatar}
        />

        <h2 style={styles.name}>{profile?.name}</h2>
        <p style={styles.username}>@{profile?.username}</p>
        <p style={styles.bio}>{profile?.bio}</p>
      </div>

      <div style={styles.posts}>
        {posts.length === 0 && <p>No posts yet</p>}

        {/** {post.formatted_scheduled_at
              ? post.formatted_scheduled_at
              :  `Created: ${new Date(post.created_at).toLocaleDateString()}`} */}
        {posts.map((post) => (
          <div key={post.id} style={styles.post}>
            <h3 style={styles.postTitle}>{post.title}</h3>
            <p style={styles.meta}>
              {post.formatted_scheduled_at || "TBD"}
            </p>
          </div>
        ))}

        {/* Blurred friend-only posts */}
        <div style={styles.blurWrapper}>

          {Array.from({ length: friendsPostCount }).map((_, index) => (

            <div key={`blur-${index}`} style={styles.postBlur}>
              <h3 style={styles.postTitleBlur}>{generateFakeText()}</h3>
              <p style={styles.metaBlur}>{generateFakeText()}</p>
            </div>


          ))}
          {/*}
             <div style={styles.overlay}>
              Friends-only post 🔒
            </div>*/}
        </div>



      </div>
      <div style={styles.ctaContainer}>
        {/*}
        <p style={styles.ctaText}>
          Add <strong>{profile?.name}</strong> to see{" "}
          <strong>{friendsPostCount}</strong> more friends-only invites 👀
        </p>*/}


        <p style={styles.ctaText}>
          {friendsPostCount > 0 ? (
            <>
              Add <strong>{profile?.name}</strong> to see{" "}
              <strong>{friendsPostCount}</strong> more friends-only invites 👀
            </>
          ) : (
            <>
              Get invites from <strong>{profile?.name}</strong>!
            </>
          )}
        </p>

        <button
          style={styles.ctaButton} //       Unlock full profile 🔓             "https://apps.apple.com/us/app/intuuch-an-artist-community/id6749470124"

          className="cta-bounce"
          onClick={() =>
            window.location.href =
            "https://apps.apple.com/us/app/id6749470124"
          }
        >
          Add {profile?.name} on Intuuch!
        </button>
      </div>
    </div>
  );
}

const styles = {
  customFontText: {
    fontFamily: "'DM Sans', sans-serif",
  },

  container: {
    width: "100%",
    maxWidth: 720, // slightly tighter than 800 for better readability
    margin: "0 auto",
    padding: "20px 14px", // more top space + balanced side padding
    boxSizing: "border-box",
    paddingBottom: "120px",//so posts don't get covered??
  },

  header: {
    textAlign: "center",
    marginBottom: 28, // more separation from posts
    marginTop: 10, // pushes everything down slightly
  },

  avatar: {
    width: 92,
    height: 92,
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
    margin: "20px auto 12px", // 👈 key: pushes image DOWN
  },

  name: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 26, // slightly bigger
    fontWeight: 600, // cleaner than 500 or 700
    margin: "6px 0 2px",
    letterSpacing: -0.3,
  },

  username: {
    color: "#888",
    fontSize: 14,
    marginBottom: 6,
  },

  bio: {
    marginTop: 6,
    fontSize: 14,
    lineHeight: 1.4,
    color: "#444",
  },

  posts: {
    marginTop: 10,
  },

  post: {
    width: "100%",
    border: "1px solid #eee",
    borderRadius: 18,
    padding: 16,
    marginBottom: 14,
    backgroundColor: "#fff",
    boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
    boxSizing: "border-box",
  },

  postTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 17,
    fontWeight: 500, //600
    marginBottom: 6,
  },

  meta: {
    fontSize: 13,
    color: "#666",
    marginTop: 4,
  },
  postBlur: {
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    backgroundColor: "#f3f3f3",
    filter: "blur(6px)",
    opacity: 0.7,
  },

  postTitleBlur: {
    margin: 0,
  },

  metaBlur: {
    fontSize: "12px",
  },
  blurWrapper: {
    position: "relative",
  },

  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "12px",
    fontWeight: "bold",
    background: "rgba(255,255,255,0.8)",
    padding: "4px 8px",
    borderRadius: "6px",
  },
  XctaContainer: {
    marginTop: "30px",
    padding: "20px",
    textAlign: "center",
    borderTop: "1px solid #eee",
  },
  ctaContainer: {
    position: "fixed",
    bottom: "20px", //  
    left: "50%",
    transform: "translateX(-50%)",
    width: "92%",
    maxWidth: "420px",
    backgroundColor: "#fff",
    padding: "20px 18px",
    borderRadius: "20px", //  
    boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    zIndex: 1000,
    textAlign: "center",
  },
  ctaText: {
    fontSize: "16px", //  18 14?? 
    marginBottom: "12px", //18 
    lineHeight: 1.6,
  },

  ctaButton: {
    width: "100%",
    padding: "16px", // 👈 bigger tap target //18
    fontSize: "18px", // 👈 larger text
    fontWeight: "700",
    borderRadius: "999px", // 👈 fully pill-shaped
    border: "none",
    background: "linear-gradient(135deg, #000, #333)",
    color: "#fff",
    cursor: "pointer",
  },

  XctaButton: {
    width: "100%",
    maxWidth: "340px",
    padding: "16px",
    fontSize: "16px",
    fontWeight: "700",
    borderRadius: "12px",
    border: "none",
    background: "linear-gradient(135deg, #000, #333)",
    color: "#fff",
    cursor: "pointer",
  },
};